declare global {
  interface Window {
    ENV?: {
      API_BASE_URL?: string;
      ENV?: string;
    };
  }
}

export const API_BASE_URL =
  (typeof window !== "undefined" ? window.ENV?.API_BASE_URL : undefined) ||
  import.meta.env.VITE_API_BASE_URL ||
  "/api";

export const CURRENT_ENV =
  (typeof window !== "undefined" ? window.ENV?.ENV : undefined) ||
  import.meta.env.VITE_ENV ||
  "local";
